import { type Theme, styled } from 'baseui';
import { HeadingXSmall, ParagraphMedium } from 'baseui/typography';
import { CircleCheckIcon } from '../../icons/circle-check-icon';
export const StyledCircleCheckIcon = styled(CircleCheckIcon, ({
  $theme
}) => ({
  outline: `5px solid ${$theme.colors.positive}`,
  borderRadius: '50%',
  width: '64px',
  height: '64px',
  outlineOffset: '-3px'
}));
export const StyledHeadingXSmall = styled(HeadingXSmall, ({
  $theme
}) => ({
  margin: 0,
  paddingTop: $theme.sizing.scale500,
  textAlign: 'center'
}));
export const StyledParagraphMedium = styled(ParagraphMedium, ({
  $theme
}) => ({
  margin: 0,
  paddingTop: $theme.sizing.scale300,
  textAlign: 'center'
}));
export const NoRemainingItemsContainer = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  marginBottom: $theme.sizing.scale800
}));
export const RemainingItemsContainer = styled('div', () => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%'
}));
export const RemainingItemsTitleContainer = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: $theme.sizing.scale200
}));
export const Container = styled('section', () => ({
  display: 'flex',
  flexDirection: 'column',
  overflow: 'auto',
  height: 'fit-content'
}));
export const ButtonContainer = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  gap: $theme.sizing.scale300
}));
export const ListItemContainer = styled<'div', {
  $isLast: boolean;
  $isExpanded: boolean;
}>('div', ({
  $theme,
  $isLast,
  $isExpanded
}: {
  $isLast: boolean;
  $isExpanded: boolean;
  $theme: Theme;
}) => ({
  display: 'flex',
  alignItems: 'center',
  padding: $isExpanded ? `${$theme.sizing.scale100} 0` : `${$theme.sizing.scale400} 0`,
  ...(!$isLast && {
    borderBottom: `1px solid ${$theme.colors.borderOpaque}`
  })
}));
export const GroupHeaderContainer = styled<'div', {
  $isExpanded: boolean;
}>('div', ({
  $theme,
  $isExpanded
}: {
  $isExpanded: boolean;
  $theme: Theme;
}) => ({
  display: 'flex',
  alignItems: 'center',
  boxSizing: 'border-box',
  padding: $isExpanded ? $theme.sizing.scale400 : `${$theme.sizing.scale400} 0`,
  ...($isExpanded && {
    backgroundColor: $theme.colors.backgroundSecondary,
    borderRadius: $theme.borders.radius300
  })
}));
export const ListItemContent = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  gap: $theme.sizing.scale100,
  alignItems: 'center',
  flex: 1,
  minWidth: 0
}));
export const ExpandedItemContainer = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  flex: 1,
  gap: $theme.sizing.scale200,
  paddingTop: $theme.sizing.scale500,
  paddingBottom: $theme.sizing.scale500
}));
export const ExpandedItemHeader = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: $theme.sizing.scale300
}));
export const ActionButtonContainer = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: $theme.sizing.scale100
}));
export const ActionButtonsRow = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: $theme.sizing.scale300,
  marginTop: $theme.sizing.scale300,
  justifyContent: 'space-between'
}));
export const AccordionHeader = styled<'div', {
  $isExpanded: boolean;
}>('div', ({
  $theme
}: {
  $theme: Theme;
}) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: `${$theme.sizing.scale600} 0`
}));
export const AccordionContent = styled<'div', {
  $isExpanded: boolean;
}>('div', ({
  $isExpanded
}: {
  $isExpanded: boolean;
  $theme: Theme;
}) => ({
  display: $isExpanded ? 'block' : 'none',
  maxHeight: $isExpanded ? 'calc(100vh - 164px)' : '0',
  overflow: $isExpanded ? 'auto' : 'hidden'
}));

// Container for any accordion
export const AccordionContainer = styled('div', () => ({
  width: '100%'
}));

// Container for nested items with left padding
export const NestedItemsContainer = styled('div', () => ({
  width: '100%'
}));
export const LoadingContainer = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: $theme.sizing.scale300,
  padding: `${$theme.sizing.scale200} ${$theme.sizing.scale500}`,
  backgroundColor: $theme.colors.backgroundTertiary,
  borderRadius: $theme.borders.radius200,
  width: 'fit-content',
  marginBottom: $theme.sizing.scale300
}));